import {
  createHoaDetailsAsync,
  deleteHoaDetailsAsync,
  getHoaDetailsAsync,
  updateHoaDetailsAsync,
} from '../../../API/order/OrderHoaAPI';
import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { createAsyncSlice } from '../../createAsyncSlice';
import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';

export const { slice: createHoaDetailsSlice, asyncAction: createHoaDetailsAction } = createAsyncSliceWithDataAndQuery(
  'createHoaDetails',
  createHoaDetailsAsync,
  {
    id: '',
    mgmtCoName: undefined,
    name: undefined,
    primaryContactEmail: undefined,
    primaryContactName: undefined,
    primaryContactPhone: undefined,
  }
);

export const { slice: getHoaDetailsSlice, asyncAction: getHoaDetailsAction } = createKeyedDataAsyncSlice(
  'getHoaDetails',
  getHoaDetailsAsync,
  (orderId) => orderId
);

export const { slice: updateHoaDetailsSlice, asyncAction: updateHoaDetailsAction } = createAsyncSlice(
  'updateHoaDetails',
  updateHoaDetailsAsync
);

export const { slice: deleteHoaDetailsSlice, asyncAction: deleteHoaDetailsAction } = createAsyncSlice(
  'deleteHoaDetails',
  deleteHoaDetailsAsync
);
